import {
  Autocomplete,
  Box,
  TextField,
  Typography
} from "@mui/material";
import React from "react";

import { DEFAULT_LOCALE, LOCALE_OPTIONS } from "../../constants";
import { LocaleSelectorProps } from "../../types";

const DEFAULT_LOCALE_OPTION = LOCALE_OPTIONS.find((opt) => opt.value === DEFAULT_LOCALE);

export const LocaleSelector: React.FC<LocaleSelectorProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  const selectedOption =
    LOCALE_OPTIONS.find((opt) => opt.value === value) ?? DEFAULT_LOCALE_OPTION;

  return (
    <Autocomplete
      disableClearable
      value={selectedOption}
      onChange={(_event, newValue) => {
        onChange(newValue.value);
      }}
      options={LOCALE_OPTIONS}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, val) => option.value === val.value}
      disabled={disabled}
      renderInput={(params) => (
        <TextField {...params} label="Locale" />
      )}
      renderOption={(props, option) => (
        <Box component="li" {...props} key={option.value}>
          <Box>
            <Typography variant="body2">{option.label}</Typography>
            <Typography variant="caption" color="text.secondary">
              {option.value}
            </Typography>
          </Box>
        </Box>
      )}
    />
  );
};
